const MEGA_MENU_OPEN_CLASS = 'mega-menu-open'
const SIDE_MENU_OPEN_CLASS = 'side-menu-open'

class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.elHeader = this.querySelector('header')
    this.elMenuButton = this.querySelector('.header__menu-button')

    this.elsDropdownDetails = Array.from(this.querySelectorAll('*[data-dropdown-menu]'))
    this.elOverlay = document.querySelector('.header__overlay')

    this.headerBounds = {}

    this.setHeaderHeight()

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this))

    this.currentScrollTop = 0
    this.preventReveal = false
    this.predictiveSearch = this.querySelector('predictive-search')

    this.onScrollHandler = this.onScroll.bind(this)
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true
    }

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.addEventListener('scroll', this.onScrollHandler, false)

    this.elMenuButton.addEventListener('click', () => {
      this.toggleSideMenu()
    })

    this.elOverlay.addEventListener('click', () => {
      this.closeSideMenu()
    })

    // this.elShopButton.addEventListener('click', (e) => {
    //   this.toggleMegaMenu(e)
    // })

    this.elsDropdownDetails.forEach(elDetails => {
      const elSummary = elDetails.querySelector('summary')
      elSummary.addEventListener('click', (e) => {
        this.toggleMegaMenu(e, elDetails)
      })
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeMegaMenu(true)
        this.closeSideMenu()
      }
    })

    const mm = gsap.matchMedia()

    mm.add('(min-width: 1024px)', () => {
      this.closeMegaMenu(true)
      this.closeSideMenu()
    })

    this.createObserver()
  }

  toggleMegaMenu(e, elDetails) {
    e.preventDefault()
    const isOpen = elDetails.hasAttribute('open')
    const elMegaMenu = elDetails.querySelector('summary ~ div')

    if (isOpen) {
      this.closeMegaMenu()
      // gsap.timeline().set(this.elHeader, { transition: 'none' })
      gsap.timeline()
      .to(elMegaMenu, { duration: 0.15, ease: 'none', opacity: 0 })
      .then(() => {
        elDetails.removeAttribute('open')
        gsap.set(elMegaMenu, { clearProps: 'all' })
      })
    } else {
      this.closeMegaMenu(true)
      elDetails.setAttribute('open', true)
      this.openMegaMenu()
      gsap.timeline()
        .from(elMegaMenu, { duration: 0.15, ease: 'none', opacity: 0 })
        .set(elMegaMenu, { clearProps: 'all' })
    }
  }

  openMegaMenu() {
    this.elHeader.classList.add(MEGA_MENU_OPEN_CLASS)
    this.elMenuButton.classList.add(MEGA_MENU_OPEN_CLASS)
    document.body.classList.add(MEGA_MENU_OPEN_CLASS)
  }

  closeMegaMenu(removeOpenAttribute = false) {
    this.elHeader.classList.remove(MEGA_MENU_OPEN_CLASS)
    this.elMenuButton.classList.remove(MEGA_MENU_OPEN_CLASS)
    document.body.classList.remove(MEGA_MENU_OPEN_CLASS)

    if (removeOpenAttribute) {
      this.elsDropdownDetails.forEach(elDetails => elDetails.removeAttribute('open'))
    }
  }

  toggleSideMenu() {
    this.elHeader.classList.toggle(SIDE_MENU_OPEN_CLASS)
    this.elMenuButton.classList.toggle(SIDE_MENU_OPEN_CLASS)
    document.body.classList.toggle(SIDE_MENU_OPEN_CLASS)
  }

  closeSideMenu() {
    this.elHeader.classList.remove(SIDE_MENU_OPEN_CLASS)
    this.elMenuButton.classList.remove(SIDE_MENU_OPEN_CLASS)
    document.body.classList.remove(SIDE_MENU_OPEN_CLASS)
  }

  setHeaderHeight() {
    setTimeout(() => {
      document.documentElement.style.setProperty('--header-height', `${this.elHeader.offsetHeight}px`)
    })
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp)
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this.elHeader)
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop

    if ((this.predictiveSearch && this.predictiveSearch.isOpen) || this.elHeader.classList.contains(SIDE_MENU_OPEN_CLASS)) { return }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.elHeader.classList.add('scrolled-past-header')
      requestAnimationFrame(this.hide.bind(this))
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.elHeader.classList.add('scrolled-past-header')
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this))
      } else {
        window.clearTimeout(this.isScrolling)

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false
        }, 66)

        requestAnimationFrame(this.hide.bind(this))
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.elHeader.classList.remove('scrolled-past-header')
      requestAnimationFrame(this.reset.bind(this))
    }

    this.currentScrollTop = scrollTop
  }

  hide() {
    this.elHeader.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky')
    this.closeMenuDisclosure()
    this.closeSearchModal()
  }

  reveal() {
    this.elHeader.classList.add('shopify-section-header-sticky', 'animate')
    this.elHeader.classList.remove('shopify-section-header-hidden')
  }

  reset() {
    this.elHeader.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate')
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.elHeader.querySelectorAll('header-menu')
    this.disclosures.forEach(disclosure => disclosure.close())
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.elHeader.querySelector('details-modal')
    this.searchModal.close(false)
  }
}

customElements.define('sticky-header', StickyHeader)
